import { useState, useEffect, useContext } from "react";
import { useController, useForm } from "react-hook-form";
import { Label, Form, FormGroup, Row, Col, Input } from "reactstrap";
import { ArrowDown, ArrowUp } from "react-feather";
import { Button } from "@mui/material";
import Select from "react-select";
import AddBoxIcon from "@mui/icons-material/AddBox";

import {
  createServiceCity,
  updateServiceCity,
} from "../../../Services/ServiceCity.service";
import { getAggregators } from "../../../Services/DispatchDashboard.service";
import { getAllCarTypes, showAlert } from "../../../Services/Shared.service";
import CustomizerContext from "../../../_helper/Customizer";

export const ServiceCityForm = (props) => {
  const { cityData, setIsSearch, isSearch, trgiggerRefresh } = props;

  const [selectedCity, setSelectedCity] = useState({});
  const [editId, setEditId] = useState(null);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [aggregatorList, setAggregatorList] = useState([]);
  const [carTypeList, setCarTypeList] = useState([]);
  const [selectAggregator, setSelectAggregator] = useState();
  const [selectCarType, setSelectCarType] = useState();
  const [newCity, setNewCity] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm({});

  const { mix_background_layout } = useContext(CustomizerContext);

  const filterCitiesById = (id) => {
    return cityData.find((city) => city.value.id === id);
  };

  const filterAggregatorById = (id) => {
    return aggregatorList.find((aggregator) => aggregator.value.id === id);
  };

  const filterCarTypesByIds = (data, ids) => {
    return data.filter((item) => ids.includes(item.value.id));
  };

  const findCarTypeIdsFromCity = (data) => {
    if (data?.value?.carType && Array.isArray(data?.value?.carType)) {
      return data.value.carType.map((car) => car.id);
    }

    return [];
  };

  const validateGSTNumber = (value) => {
    const regex = /^[a-zA-Z0-9]*$/;
    if (value.length != 15) {
      return "GST No must be 15 characters";
    }
    if (!regex.test(value)) {
      return "GST No must not contain special characters";
    }
    return true;
  };

  const isWalletEnabledField = useController({
    name: "isWalletEnabled",
    control,
  }).field;

  const newServiceCity = () => {
    setEditId(null);
    setNewCity(true);
    handleToggle();
    resetFormData();
  };

  const existingSelectedCity = (selectedData) => {
    setEditId(selectedData.id);
    setNewCity(false);
    handleToggle();
  };

  const handleToggle = () => {
    setIsSearch(!isSearch);
  };

  const resetFormData = () => {
    reset({
      name: "",
      companyName: "",
      aggregator: "",
      placeOfSupply: "",
      invoiceLabel: "",
      address: "",
      digitalSignUrl: "",
      cityCode: "",
      callCentreMobile: "",
      registeredOfficeAddress: "",
      website: "",
      sacCode: "",
      gstNo: "",
      cinNo: "",
      serviceDesc: "",
      isWalletEnabled: false,
      oldCompanyName: "",
      shortDistance: "",
      oldAddress: "",
      oldCinNo: "",
      oldGstNo: "",
      rideNowSec: "",
      rideLaterSec: "",
      carType: "",
    });

    setSelectAggregator();
    setSelectCarType();
  };
  
  const onFormSubmit = (formValues) => {
    const filteredCarType = formValues.carType.map((item) => item.value);

    const body = {
      name: formValues.name ? formValues.name : null,
      companyName: formValues.companyName ? formValues.companyName : null,
      oldCompanyName: formValues.oldCompanyName
        ? formValues.oldCompanyName
        : null,
      address: formValues.address ? formValues.address : null,
      gstNo: formValues.gstNo ? formValues.gstNo : null,
      shortDistance: formValues.shortDistance ? formValues.shortDistance : null,
      invoiceLabel: formValues.invoiceLabel ? formValues.invoiceLabel : null,
      cityCode: formValues.cityCode ? formValues.cityCode : null,
      aggregatorId: selectAggregator?.value?.id
        ? selectAggregator?.value?.id
        : null,
      aggregatorCompanyName: newCity
        ? formValues.aggregator
          ? formValues.aggregator.label
          : null
        : formValues.aggregator
        ? formValues.aggregator.label
        : null,
      biddingDurationSecondsRidelater: formValues.rideLaterSec
        ? formValues.rideLaterSec
        : null,
      biddingDurationSecondsRidenow: formValues.rideNowSec
        ? formValues.rideNowSec
        : null,
      serviceDescription: formValues.serviceDesc
        ? formValues.serviceDesc
        : null,
      sacCode: formValues.sacCode ? formValues.sacCode : null,
      placeOfSupply: formValues.placeOfSupply ? formValues.placeOfSupply : null,
      cinNo: formValues.cinNo ? formValues.cinNo : null,
      registeredOfficeAddress: formValues.registeredOfficeAddress
        ? formValues.registeredOfficeAddress
        : null,
      website: formValues.website ? formValues.website : null,
      digitalSignatureUrl: formValues.digitalSignUrl
        ? formValues.digitalSignUrl
        : null,
      digitalSignatureUrlContentType: "image/jpeg",
      oldAddress: formValues.oldAddress ? formValues.oldAddress : null,
      oldGstNo: formValues.oldGstNo ? formValues.oldGstNo : null,
      oldCinNo: formValues.oldCinNo ? formValues.oldCinNo : null,
      isIgstApplyOn: null,
      isWalletEnabled: formValues.isWalletEnabled ? true : false,
      callCenterMobile: formValues.callCentreMobile
        ? formValues.callCentreMobile
        : null,
      carType: filteredCarType ? filteredCarType : null,
      isDeleted: selectedCity?.value ? selectedCity?.value?.isDeleted : false,
      deletedOn:selectAggregator?.value?.deletedOn ? selectAggregator?.value?.deletedOn:null,
      deletedById:selectAggregator?.value?.deletedById ? selectAggregator?.value?.deletedById:null,
      createdOn:selectAggregator?.value?.createdOn ? selectAggregator?.value?.createdOn:null,
      createdById:selectAggregator?.value?.createdById ? selectAggregator?.value?.createdById:null,
     



    };

    if (editId != null) {
      body["id"] = editId;
      updateServiceCity(body)
        .then((res) => {
          setIsSearch(true);
          trgiggerRefresh();

          showAlert("success", "Service city updated successfully");
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    } else {
      createServiceCity(body)
        .then((res) => {
          setIsSearch(true);
          trgiggerRefresh();

          showAlert("success", "Service city created successfully");
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  };

  useEffect(() => {
    getAggregators().then((result) => {
      if (result.data) {
        const data = result.data.map((element) => {
          return {
            label: element.companyName,
            value: element,
          };
        });
        setAggregatorList(data);
      }
    });

    getAllCarTypes({ page: 0, size: 30 })
      .then((result) => {
        if (result.data) {
          const data = result.data.content.map((element) => {
            return {
              label: element.name,
              value: element,
            };
          });

          setCarTypeList(data);
        }
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Unable to fetch Car details for selected City"
        );
      });
  }, []);

  useEffect(() => {
    const selectedCityData = filterCitiesById(editId);

    setSelectedCity(selectedCityData);

    const selectedAggregatorData = filterAggregatorById(
      selectedCityData?.value?.aggregatorId
    );

    setSelectAggregator(selectedAggregatorData);

    const carTypeIdFromCity = findCarTypeIdsFromCity(selectedCityData);

    const selectedCars = filterCarTypesByIds(carTypeList, carTypeIdFromCity);

    setSelectCarType(selectedCars);

    reset({
      name: selectedCityData?.value?.name ? selectedCityData?.value?.name : "",
      companyName: selectedCityData?.value?.companyName
        ? selectedCityData?.value?.companyName
        : "",
      aggregator: selectedCityData?.value?.aggregatorCompanyName
        ? selectedCityData?.value?.aggregatorCompanyName
        : "",
      placeOfSupply: selectedCityData?.value?.placeOfSupply
        ? selectedCityData?.value?.placeOfSupply
        : "",
      invoiceLabel: selectedCityData?.value?.invoiceLabel
        ? selectedCityData?.value?.invoiceLabel
        : "",
      address: selectedCityData?.value?.address
        ? selectedCityData?.value?.address
        : "",
      digitalSignUrl: selectedCityData?.value?.digitalSignatureUrl
        ? selectedCityData?.value?.digitalSignatureUrl
        : "",
      cityCode: selectedCityData?.value?.cityCode
        ? selectedCityData?.value?.cityCode
        : "",
      callCentreMobile: selectedCityData?.value?.callCenterMobile
        ? selectedCityData?.value?.callCenterMobile
        : "",
      registeredOfficeAddress: selectedCityData?.value?.registeredOfficeAddress
        ? selectedCityData?.value?.registeredOfficeAddress
        : "",
      website: selectedCityData?.value?.website
        ? selectedCityData?.value?.website
        : "",
      sacCode: selectedCityData?.value?.sacCode
        ? selectedCityData?.value?.sacCode
        : "",
      gstNo: selectedCityData?.value?.gstNo
        ? selectedCityData?.value?.gstNo
        : "",
      cinNo: selectedCityData?.value?.cinNo
        ? selectedCityData?.value?.cinNo
        : "",
      serviceDesc: selectedCityData?.value?.serviceDescription
        ? selectedCityData?.value?.serviceDescription
        : "",
      isWalletEnabled: selectedCityData?.value?.isWalletEnabled
        ? selectedCityData?.value?.isWalletEnabled
        : "",
      oldCompanyName: selectedCityData?.value?.oldCompanyName
        ? selectedCityData?.value?.oldCompanyName
        : "",
      shortDistance: selectedCityData?.value?.shortDistance
        ? selectedCityData?.value?.shortDistance
        : "",
      oldAddress: selectedCityData?.value?.oldAddress
        ? selectedCityData?.value?.oldAddress
        : "",
      oldCinNo: selectedCityData?.value?.oldCinNo
        ? selectedCityData?.value?.oldCinNo
        : "",
      oldGstNo: selectedCityData?.value?.oldGstNo
        ? selectedCityData?.value?.oldGstNo
        : "",
      rideNowSec: selectedCityData?.value?.biddingDurationSecondsRidenow
        ? selectedCityData?.value?.biddingDurationSecondsRidenow
        : "",
      rideLaterSec: selectedCityData?.value?.biddingDurationSecondsRidelater
        ? selectedCityData?.value?.biddingDurationSecondsRidelater
        : "",
      carType: selectedCityData?.value?.carType
        ? selectedCityData?.value?.carType
        : "",
    });
  }, [editId]);

  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Button
              sx={{
                width: "100%",
                fontSize: "1rem",
                color: "#41CC7D",
                borderColor: "#41CC7D",
                "&:hover": {
                  borderColor: "#41CC7D",
                },
              }}
              variant="outlined"
              startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
              onClick={newServiceCity}
            >
              New Service City
            </Button>

            <Select
              placeholder={"Select Existing Service City"}
              cacheOptions
              options={cityData}
              onChange={existingSelectedCity}
            />
          </div>
        </div>
      ) : (
        <div>
          <Form onSubmit={handleSubmit(onFormSubmit)}>
            <Row>
              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Name</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "Name is required",
                      },
                      onChange: (e) => {
                        setValue("name", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>{errors?.name?.message}</span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Company Name</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("companyName", {
                      required: {
                        value: true,
                        message: "Company Name is required",
                      },
                      onChange: (e) => {
                        setValue("companyName", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.companyName?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Aggregator</Label>

                <Col lg="12">
                  <Select
                    value={selectAggregator}
                    options={aggregatorList}
                    onChange={(e) => {
                      setValue("aggregator", e);
                      setSelectAggregator(e);
                    }}
                    isSearchable={true}
                    placeholder={"Select Aggregator"}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.aggregator?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Place of Supply
                </Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("placeOfSupply", {
                      required: {
                        value: true,
                        message: "Place of Supply is required",
                      },
                      onChange: (e) => {
                        setValue("placeOfSupply", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.placeOfSupply?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>

            <Row>
              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Invoice Label
                </Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("invoiceLabel", {
                      required: {
                        value: true,
                        message: "Invoice Label is required",
                      },
                      onChange: (e) => {
                        setValue("invoiceLabel", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.invoiceLabel?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Address</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("address", {
                      required: {
                        value: true,
                        message: "Address is required",
                      },
                      onChange: (e) => {
                        setValue("address", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.address?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Digital Signature URL
                </Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("digitalSignUrl", {
                      required: {
                        value: true,
                        message: "Digital Signature URL is required",
                      },
                      onChange: (e) => {
                        setValue("digitalSignUrl", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.digitalSignUrl?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">City Code</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("cityCode", {
                      required: {
                        value: true,
                        message: "City Code is required",
                      },
                      onChange: (e) => {
                        setValue("cityCode", e.target.value.trimStart());
                      },
                      validate: (value) =>
                        value.length <= 3 ||
                        "City code must be 3 characters or less",
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.cityCode?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>

            <Row>
              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Call Centre Mobile
                </Label>

                <Col lg="12">
                  <>
                    <input
                      className="form-control no-arrows"
                      type="number"
                      {...register("callCentreMobile", {
                        required: {
                          value: true,
                          message: "Call Centre Mobile is required",
                        },
                        onChange: (e) => {
                          setValue(
                            "callCentreMobile",
                            e.target.value.trimStart()
                          );
                        },
                        validate: (value) =>
                          value.length == 10 ||
                          "Call centre mobile must be 10 digits",
                      })}
                      onInput={(e) => {
                        if (e.target.value.length > 10) {
                          e.target.value = e.target.value.slice(0, 10);
                        }
                      }}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.callCentreMobile?.message}
                    </span>

                    <style>
                      {`
                        /* Chrome, Safari, Edge, Opera */
                        .no-arrows::-webkit-outer-spin-button,
                        .no-arrows::-webkit-inner-spin-button {
                          -webkit-appearance: none;
                          margin: 0;
                        }

                        /* Firefox */
                        .no-arrows[type="number"] {
                          -moz-appearance: textfield;
                        }
                      `}
                    </style>
                  </>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Registered Office Address
                </Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("registeredOfficeAddress", {
                      required: {
                        value: true,
                        message: "Registered Office Address is required",
                      },
                      onChange: (e) => {
                        setValue(
                          "registeredOfficeAddress",
                          e.target.value.trimStart()
                        );
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.registeredOfficeAddress?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Website</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("website", {
                      required: {
                        value: true,
                        message: "Website is required",
                      },
                      onChange: (e) => {
                        setValue("website", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.website?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">SAC Code</Label>

                <Col lg="12">
                  <>
                    <input
                      className="form-control no-arrows"
                      type="number"
                      {...register("sacCode", {
                        required: {
                          value: true,
                          message: "SAC Code is required",
                        },
                        onChange: (e) => {
                          setValue("sacCode", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.sacCode?.message}
                    </span>

                    <style>
                      {`
                        /* Chrome, Safari, Edge, Opera */
                        .no-arrows::-webkit-outer-spin-button,
                        .no-arrows::-webkit-inner-spin-button {
                          -webkit-appearance: none;
                          margin: 0;
                        }

                        /* Firefox */
                        .no-arrows[type="number"] {
                          -moz-appearance: textfield;
                        }
                      `}
                    </style>
                  </>
                </Col>
              </FormGroup>
            </Row>

            <Row>
              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">GST No.</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    maxLength="15"
                    {...register("gstNo", {
                      required: {
                        value: true,
                        message: "GST No is required",
                      },
                      onChange: (e) => {
                        setValue("gstNo", e.target.value.trimStart());
                      },
                      validate: validateGSTNumber,
                    })}
                  />

                  <span style={{ color: "red" }}>{errors?.gstNo?.message}</span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">CIN No.</Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("cinNo", {
                      required: {
                        value: true,
                        message: "CIN No is required",
                      },
                      onChange: (e) => {
                        setValue("cinNo", e.target.value.trimStart());
                      },
                      validate: (value) =>
                        value.length == 21 || "CIN No must be 21 characters",
                    })}
                  />

                  <span style={{ color: "red" }}>{errors?.cinNo?.message}</span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Service Description
                </Label>

                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("serviceDesc", {
                      required: {
                        value: true,
                        message: "Service Description is required",
                      },
                      onChange: (e) => {
                        setValue("serviceDesc", e.target.value.trimStart());
                      },
                    })}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.serviceDesc?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">Car Type</Label>

                <Col lg="12">
                  <Select
                    isMulti
                    value={selectCarType}
                    options={carTypeList}
                    onChange={(e) => {
                      setValue("carType", e);
                      setSelectCarType(e);
                    }}
                    isSearchable={true}
                    placeholder={"Select Car Type"}
                  />

                  <span style={{ color: "red" }}>
                    {errors?.carType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup
                className="col-lg-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Input
                    id="isWalletEnabled"
                    type="checkbox"
                    checked={isWalletEnabledField.value}
                    onChange={(value) => isWalletEnabledField.onChange(value)}
                  />
                  <Label className="mb-0" for="isWalletEnabled">
                    {"Wallet Enabled"}
                  </Label>
                </div>
              </FormGroup>
            </Row>

            <Row>
              <div
                style={{
                  color: "#11BF5C",
                  textDecoration: "underline",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                Advanced Configurations{" "}
                {isAdvanced ? (
                  <ArrowUp
                    style={{
                      width: "15px",
                      height: "15px",
                      marginLeft: "5px",
                    }}
                  />
                ) : (
                  <ArrowDown
                    style={{
                      width: "15px",
                      height: "15px",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </div>
            </Row>

            {/* Advance Config */}

            {isAdvanced ? (
              <Row>
                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Old Company Name
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("oldCompanyName", {
                        onChange: (e) => {
                          setValue(
                            "oldCompanyName",
                            e.target.value.trimStart()
                          );
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.oldCompanyName?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Short Distance
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("shortDistance", {
                        onChange: (e) => {
                          setValue("shortDistance", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.shortDistance?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Old Address
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("oldAddress", {
                        onChange: (e) => {
                          setValue("oldAddress", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.oldAddress?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Old CIN No.
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("oldCinNo", {
                        onChange: (e) => {
                          setValue("oldCinNo", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.oldCinNo?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Old GST No.
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("oldGstNo", {
                        onChange: (e) => {
                          setValue("oldGstNo", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.oldGstNo?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Bidding duration seconds ride now
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("rideNowSec", {
                        onChange: (e) => {
                          setValue("rideNowSec", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.rideNowSec?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-3">
                  <Label className="col-lg-12 col-form-label">
                    Bidding duration seconds ride later
                  </Label>

                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("rideLaterSec", {
                        onChange: (e) => {
                          setValue("rideLaterSec", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.rideLaterSec?.message}
                    </span>
                  </Col>
                </FormGroup>
              </Row>
            ) : null}

            {/* Advance Config */}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button type="submit" className="btn submit-button">
                {editId ? "Update" : "Create"}
              </button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
};

export default ServiceCityForm;
